import { render, staticRenderFns } from "./金融服务_银行列表_获嘉县.vue?vue&type=template&id=255a7c53&scoped=true"
import script from "./金融服务_银行列表_获嘉县.vue?vue&type=script&lang=js"
export * from "./金融服务_银行列表_获嘉县.vue?vue&type=script&lang=js"
import style0 from "./金融服务_银行列表_获嘉县.vue?vue&type=style&index=0&id=255a7c53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255a7c53",
  null
  
)

export default component.exports